import BaseModel from "../api/models/BaseModel";
import CollectionItem from "./CollectionItem";

/**
 * Collection
 * This class is a helper for arrays of objects, containing helpfull methods to filter, get and handle arrays
 */
export default class Collection extends BaseModel{

    /**
     * Construct this collection with sent parameters
     * @param {Array} data
     * @param {String} key
     */
    constructor(arr = [], key = null) {
        super();
        this.parsed = {};
        this.data   = arr;
        this.key    = key;
        this.build();
    }

    /**
     * Builds parsed data accordingly to sent key
     * @param {String} key
     * @param {Array} data
     */
    build(key = null, data = null) {
        if(key)
            this.key = key;
        if(data)
            this.data = data;
        if (this.key) {
            let index = 0;
            for (let item of this.data) {
                let value = null;
                try {
                    value = ![undefined,null,false,true].includes(item[this.key]) ? item[this.key] : null;
                } catch (error) {
                    value = null;                    
                }
                let thisKey = value ? value : index;
                this.parsed[thisKey] = this.isCollectionItem(item) ? item : this.parseToCollectionItem(thisKey, item);
                index++;
            }
        } 

        let newData = [];
        for (let i = 0; i < this.data.length; i++) {
            const item = this.isCollectionItem(this.data[i]) ? this.data[i] : this.parseToCollectionItem(i, this.data[i]);
            newData.push(item);
        }
        this.data = newData;
    }

    /**
     * Parses sent value to CollectionItem
     * @param {*} index 
     * @param {*} value 
     * @returns {CollectionItem}
     */
    parseToCollectionItem(index = null, value = null) {
        return new CollectionItem(index, value);
    }

    /**
     * Checks if sent value is an object of type 'CollectionItem'
     * @param {*} value 
     * @returns {Boolean}
     */
    isCollectionItem(value = null) {
        try {
            return value.className == 'CollectionItem' ? true : false;
        } catch (error) {
            return false;
        }
    }

    /**
     * Gets raw data from 'this.data' attr
     * @returns {Array|Null}
     */
    get(index = null) {
        if(index)
            return this.parsed[index] != undefined ? this.parsed[index] : null;
        return this.parsed;
    }

    /**
     * Gets raw data from 'this.data' attr
     * @returns {Array}
     */
    raw() {
        return this.data;
    }

    /**
     * Checks if collection is empty
     * @returns {Array}
     */
    empty() {
        return this.data.length > 0 ? false : true;
    }

    /**
     * Checks if index exist in this.parsed collection
     * @param {String} key
     * @returns {boolean}
     */
    exists(key = null) {
        return this.get(key) != null ? true : false;
    }

    /**
     * Checks if this.parsed item has sent value on sent attr name
     * @param {String} key 
     * @param {*} val 
     * @param {*} index
     * @returns {Collection}
     */
    exitsIn(key = null, val = null, index = null) {
        const foundData = index != null ? this.get(index) : this.parsed;
        if(foundData == null || [null,undefined,''].includes(key))
            return false;
        let dataToReturn = [];
        if (foundData != null){
            if (Array.isArray(foundData)) {
                for (let item of foundData) {
                    if(item[key].isValue(val))
                        dataToReturn.push(item);
                }
            } else if(typeof foundData === 'object' && !Array.isArray(foundData) && foundData !== null) {
                for (let item of Object.keys(foundData)) {
                    if(foundData[item].getValue()[key] != undefined && foundData[item].getValue()[key] == val)
                        dataToReturn.push(foundData[item]);
                }
            }
        } else {
            if(foundData[key].isValue(val))
                dataToReturn.push(foundData[key]);
        }

        // Must check here why it makes an CollectionItem inside another collectionItem
        return new Collection(dataToReturn);
    }

    /**
     * Gets an iterable data
     * @returns {Array}
     */
    items() {
        return this.raw();
    }

    /**
     * Gets this.data size
     * @returns {Integer}
     */
    size() {
        if (!Array.isArray(this.items()) || [undefined,null,false].includes(this.items()))
            return 0;
        return this.items().length;
    }

    /**
     * Gets this.parsed as iterable array
     * @returns {Array}
     */
    parsedItems() {
        let iterableArray = [];

        for (let key of Object.keys(this.parsed)) {
            iterableArray.push(this.parsed[key].getValue());
        }

        return iterableArray;
    }
}